var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLineandbar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.53 2.53a.75.75 0 0 0-1.06-1.06L8.852 6.087 5.335 4.33a.75.75 0 0 0-.904.183l-3 3.5a.75.75 0 1 0 1.138.976l2.62-3.055L8.664 7.67a.75.75 0 0 0 .865-.14l5-5zM12.25 8a.75.75 0 0 0-.75.75V14H14V8.75a.75.75 0 0 0-.75-.75h-1zm-5.4 2.375c-.1.174-.1.408-.1.875V14h2.5v-2.75c0-.467 0-.701-.1-.875a.75.75 0 0 0-.275-.274C8.701 10 8.467 10 8 10s-.701 0-.875.1a.75.75 0 0 0-.275.275zM2 11.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75V14H2v-2.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLineandbar);
export default ForwardRef;